<!--会诊单组件-->
<template>
    <div class="consul-deal clearfix">
        <div class="deal-content marginP " >
            <div class="part-right consul-deal-part mypatient" v-loading="!isSuccess">
                <div class="evaluate-wrap consul-sheet-wrap deal-sheet-wrap" v-if="isSuccess">
                    <div  class="consul-part1 part">
                        <ImageAmplify/>
                        <div class="video-Top">
                            <label class="searchTip">远程会诊申请信息</label>
                        </div>
                        <div class=" clearfix">
                            <div class="sheet-content number-wrap clearfix">
                                <label class="fl order-num jet-black">NO.{{ consultDetail.consult.consultGroupNo }}</label>
                                <label class="fr order-num jet-black">问诊费用：<span class="fee-num">￥{{ consultDetail.consult.consultFee }}</span></label>
                            </div>
                            <div class="clearfix h30 paddingL20 marginT5">
                                <span class="name patient-list-item jet-black lineH30 fontSize14">{{ consultDetail.consult.consulterName }}</span>
                                <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consult.consulterGender =="M"?"男":"女" }}</span>
                                <span class="patient-list-item lineH30 jet-gray">{{ consultDetail.consult.consulterAge }}岁</span>
                                <span class="patient-list-item lineH30 jet-gray">电话：{{ consultDetail.consult.consulterMobile }}</span>
                                <span class="patient-list-item lineH30 jet-gray">身份证：{{ consultDetail.consult.consulterIdcard }}</span>
                                <span class="patient-list-item lineH30 jet-gray">职业：{{ consultDetail.consult.consulterJob }}</span>
                                <span class="patient-list-item lineH30 jet-gray">患者住院号：{{ consultDetail.consult?consultDetail.consult.consulterInhosno:'无' }}</span>
                            </div>
                            <div class="patient-form sheet-content">
                                <div class=" marginB10 paddingT10">
                                    <span class="jet-gray">邀请会诊医生：</span>{{acceptDoc}}
                                    <span class="jet-gray marginL20">邀请会诊时间：</span>{{consultDetail.consult.hopeTime?consultDetail.consult.hopeTime:'无'}}
                                </div>
                                <div class="lineH22 marginB10">
                                    <span class="jet-gray">申请类型：</span>{{ consultDetail.consult.consultGroupType }}
                                    <span class="jet-gray marginL20">辅助诊断类型：</span>{{ consultDetail.consult.auxiliaryDiagnose }}
                                </div>
                                <div class="bgc-white">
                                    <div class="lineH22 marginB10">
                                        <span class="jet-gray">患者主诉：</span>
                                        <div class="linecon">
                                        {{ consultDetail.consult.consultContent }}
                                        </div>
                                    </div>
                                    <div class="lineH22 marginB10">
                                        <span class="jet-gray">初步诊断：</span>
                                        <div class="linecon">
                                        {{ consultDetail.consult.beforeDiagnose }}
                                        </div>
                                    </div>
                                    <div class="lineH22 marginB10">
                                        <span class="jet-gray">会诊目的：</span>
                                        <div class="linecon">
                                        {{ consultDetail.consult.consultReason }}
                                        </div>
                                    </div>
                                </div>
                                <el-form :model="formData" label-position="left" label-width="85px" class="bgc-white">
                                    <div class="add-pic-list">
                                        <img v-for="(item,index) in imgList" class="item-pic w88 h88 marginR10" :src="item.url" :key="index" @click="handleImageAmplify(index, imgList, $event)">
                                    </div>
                                    <ul class="el-upload-list el-upload-list--text">
                                        <li class="el-upload-list__item is-success" v-for="(item, index) in fileList" :key="index">
                                            <a class="el-upload-list__item-name" :href="item.url" target="_blank">
                                                <i class="el-icon-document"></i>
                                                {{ item.attaFileName }}
                                            </a>
                                        </li>
                                    </ul>
                                </el-form>
                                <div class="consul-form-item h30 bgc-white">
                                    <div class="fr">
                                        <label class="light-gray">创建时间：</label>
                                        <span class="label-content light-gray">{{ formatUnix(consultDetail.consult.createTime) }}</span>
                                        <label class="light-gray">创建人：</label>
                                        <span class="light-gray">{{ consultDetail.consult.initHosName+' - '+consultDetail.consult.initDeptName+' - '+consultDetail.consult.initDocName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="video-Top">
                        <label class="searchTip">会诊信息</label>
                    </div>
                    <div class="opinionPart sheet-content evaluate-launch-wrap marginT10 clearfix">
                        <div class="lineH22 marginB10 fl">
                            <span class="jet-gray">会诊医生：</span>{{ consultDetail.consult.acceptDocName?(consultDetail.consult.acceptHosName+' - '+consultDetail.consult.acceptDeptName+' - '+consultDetail.consult.acceptDocName):'无'}}
                        </div>
                        <div class="lineH22 marginB10 fr">
                            <span class="jet-gray">视频时间：</span>{{ videoTime }}
                        </div>
                    </div>
                    <div class="video-Top">
                        <label class="searchTip">会诊意见</label>
                    </div>
                    <div class="opinionPart sheet-content evaluate-launch-wrap marginT10">
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">会诊意见：</span>{{ consultDetail.consult.consultAdvice }}
                        </div>
                    </div>
                    <div class="video-Top">
                        <label class="searchTip">评价</label>
                    </div>
                    <div class="sheet-content evaluate-bottom-content evaluate-launch-wrap paddingT10">
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">会诊前后诊断符合情况：</span>{{ equalDiagnose }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">符合否建议转诊：</span>{{ transfer }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">对方系统运行效果评价：</span>{{ consultDetail.consult.systemScore?consultDetail.consult.systemScore:'无' }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">对方病历质量评价：</span>{{ consultDetail.consult.medicalScore?consultDetail.consult.medicalScore:'无' }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">对方辅助诊断资料质量评价：</span>{{ consultDetail.consult.recordScore?consultDetail.consult.recordScore:'无' }}
                        </div>
                        <div class="lineH22 marginB10">
                            <span class="jet-gray">对方病史复述能力评价：</span>{{ consultDetail.consult.recordScore?consultDetail.consult.recordScore:'无' }}
                        </div>
                        <div class="consul-form-item h30 bgc-white marginB20">
                            <div class="fr">
                                <label class="light-gray">处理时间：</label>
                                <span class="label-content light-gray">{{ consultDetail.consult.modifyTime?formatUnix(consultDetail.consult.modifyTime):'无'}}</span>
                                <label class="light-gray">处理人：</label>
                                <span class="light-gray">{{ consultDetail.consult.modifyTime?consultDetail.consult.modifierName:''}}</span>
                            </div>
                        </div>
                        <div class="blue-btn-wrap">
                            <el-button type="primary" size="small" class="blue-btn w80 marginB20 marginT20" @click="printPreView">打印</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
    import { Loading } from "element-ui";
    import {upLoadBasicParam} from "../../data/basicParam.js";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import ImageAmplify from "../common/ImageAmplify.vue";
    import fileClassification from "../../utils/FileClassificationUtils";
    import { imageAmplify } from "../../utils/AmplifyImage.js";
    import { formatUnixTime } from "../../utils/DateFormat.js"
    import Vue from "vue";
    Vue.use(Loading);
    export default{
        data: function(){
            return {
                consultDetail: null,//会诊单详细信息
                selectDoctor: "",//选择会诊医生
                isSuccess: false,//是否加载成功
                //consultId: this.$route.params.consultId,//获取会诊单编号

                imgList: [],//获取附件图片
                fileList: [],//获取附件文件
            }
        },
        components: {
            ImageAmplify
        },
        created: function(){//获取会诊单数据
            this.getConsultDetail();
        },
        watch: {
            // 如果路由有变化，会再次执行获取会诊单方法
            "$route": "getConsultDetail"
        },
        computed: {
            acceptDoc: function () {//期望医生
                let consult = this.consultDetail.consult;
                if(consult.hopeHosName&&consult.hopeDeptName){
                    if(consult.hopeDocName){
                        return consult.hopeHosName + ' - ' + consult.hopeDeptName + ' - ' + consult.hopeDocName;
                    }else {

                        return consult.hopeHosName + ' - ' + consult.hopeDeptName;
                    }
                }else {
                    return '无';
                }
            },
            consultId: function(){//获取会诊单编号
                return this.$route.params.consultId;//获取会诊单编号
            },
            equalDiagnose: function () {//会诊前后是否符合情况
                if(this.consultDetail.consult.equalDiagnose==true){
                    return "是";
                }else if(this.consultDetail.consult.equalDiagnose==false){
                    return "否";
                }else {
                    return "无";
                }
            },
            transfer: function () {//是否建议转诊
                if(this.consultDetail.consult.transfer==true){
                    return "是";
                }else if(this.consultDetail.consult.transfer==false){
                    return "否";
                }else {
                    return "无";
                }
            },
            videoTime: function () {//视频时间
                let video = this.consultDetail.video;
                if(video){
                    if(video.endTime){
                        return ('【'+this.formatUnix(video.startTime)+'】'+' - '+'【'+this.formatUnix(video.endTime)+'】');
                    }else {
                        return ('【'+this.formatUnix(video.startTime)+'】'+' - '+'【-】');
                    }
                }else {
                    return '【-】';
                }
            }
        },
        mounted:function(){
//          this.printPreView();
        },
        methods:{
        	handleImageAmplify:function(index=0, imgList=[], ev){//点击图片放大
        		let e = ev || event;
                let element = e.target || e.srcElement;
                let src = element.src;
                let obj = {
                    imgList: imgList,
                    index: index
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(src);
        	},
        	formatUnix: function(time){//将unix时间戳转换未yyyy-MM-dd HH:mm
        	     return formatUnixTime(time);
        	},
        	getConsultDetail: function(){//根据consultId获取会诊单数据
                let _this = this;
                let options = {
                    consultId: _this.consultId,
                    token: localStorage.getItem("token"),
                    Service: "smarthos.consult.group.detail"
                };
                axiosUtil(options, function(data){
                    _this.isSuccess = true;
                    _this.consultDetail = data.obj;
                    //获取附件并分组图片和文件
                    fileClassification(data.obj.attaList, _this.imgList, _this.fileList);
                }, function () {
                    _this.isSuccess = true;
                    _this.$router.go(-1);
                });
            },
            printPreView: function(){// 打印预览按钮
                this.$store.dispatch("getPrintDetail", this.consultDetail);// 获取需要打印的数据
                this.$router.push({ name: "printRemoteSheet", params: { consultId: this.consultId }} );
            }
        }
    }
</script>
